import * as React from 'react';
import { useYotpo } from '../../../utils/useYotpo';
import './productRating.scss';

const ProductRating = ({ productId }) => {
  const { getProductRating } = useYotpo();
  const idProductRating = getProductRating();
  return (
    <div
      className="yotpo-widget-instance product-rating"
      data-yotpo-instance-id={idProductRating}
      data-yotpo-product-id={productId}
    />
  );
};

export default ProductRating;
